/**
 * Keeps the stored ad click IDs in the URL on every navigation, adding any the URL
 * doesn't carry (RVZ-28582). A click ID already in the URL is never replaced, and one
 * past its platform's attribution window is no longer added.
 *
 * A page loaded without them (a bookmark, a link opened in a new tab) is redirected by
 * the server, so the page is never rendered without them.
 */
export default defineNuxtRouteMiddleware((to) => {
  // The server has already redirected the page being hydrated.
  if (isMetaClient && useNuxtApp().isHydrating) {
    return
  }

  const { isPotentiallyABot } = useBotScore()

  if (isPotentiallyABot) {
    return
  }

  const redirect = getClickIdsRedirect(to, parseLiveClickIds(useClickIdsCookie().value))

  if (!redirect) {
    return
  }

  // A plain redirect keeps the navigation's own push or replace, so Back still works.
  return navigateTo(redirect)
})
